import { render, staticRenderFns } from "./SwitchViewForAdmin.vue?vue&type=template&id=073e4355&scoped=true"
import script from "./SwitchViewForAdmin.vue?vue&type=script&lang=ts"
export * from "./SwitchViewForAdmin.vue?vue&type=script&lang=ts"
import style0 from "./SwitchViewForAdmin.vue?vue&type=style&index=0&id=073e4355&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073e4355",
  null
  
)

export default component.exports